import { Link } from "react-router-dom";
import logoImage from "./../../assets/ayushi_log.6e5fc2d9bf89245e0c93.png";

const handleFooterLink = () => {
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  });
};

function BlogCard({ title, description, link, image, imageAlt, date }) {
  let introContent = "";

  // Simple approach: first paragraph is intro, rest is main content

  const contentWithoutTags = description.replace(/<[^>]*>/g, " ");
  const firstParagraphEnd = contentWithoutTags.indexOf("\n\n");

  if (firstParagraphEnd > 0) {
    introContent = contentWithoutTags.substring(0, firstParagraphEnd);
  } else {
    // If no clear paragraph break, use the first 150 characters as intro
    introContent = contentWithoutTags.substring(0, 200) + "...";
  }
  return (
    <div className="col-12 col-lg-4 col-md-6 mb-4">
      <Link
        to={link}
        onClick={handleFooterLink}
        className="text-white text-decoration-none"
      >
        <div
          className="card shadow p-3 mb-5 bg-white rounded"
          style={{ height: "33rem", overflow: "hidden" }}
        >
          <img
            src={image || logoImage}
            className="card-img-top"
            alt={imageAlt || title}
            style={{ objectFit: "fit", width: "100%", height: "15rem" }}
          />
          <div className="card-body">
            <h5
              className="card-title mt-2"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "normal",
              }}
            >
              {title}
            </h5>
            <p
              className="card-text clamp-3"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "normal",
              }}
              dangerouslySetInnerHTML={{ __html: introContent }}
            ></p>
          </div>
          {/* <p className="card-text text-black mb-0" style={{fontSize: "0.8rem"}}>
            Written by... <br />DOAGuru Infosystems
            </p>
          <p className="card-text text-black" style={{fontSize: "0.7rem"}} ><em> {date}</em></p> */}

          <div
            className="d-flex justify-content-between align-items-center px-2"
            style={{ fontSize: "0.8rem", color: "black" }}
          >
            <p className="mb-0" style={{ color: "black", fontWeight: "500" }}>
              Written by... <br />
              Ayushi Construction
            </p>
            <p
              className="mb-0"
              style={{ marginTop: "1.5rem", color: "black", fontWeight: "500" }}
            >
              <em>{date}</em>
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default BlogCard;
